$(document).ready(function () {
  function updateCart() {
    var currentUrl = window.location.href;
    $.ajax({
      url: currentUrl,
      type: "GET",
      success: function (resdata) {
        var htmld = $(resdata).find(".cart-drawer").html();
        if (htmld === undefined) {
          htmld = $(resdata).filter(".cart-drawer").html();
        }
        $(document).find(".cart-drawer").html(htmld);
      },
    });
  }
  function changeCart(id, qty) {
    $.ajax({
      url: "/cart/change.js",
      type: "POST",
      data: { id: id, quantity: qty },
      dataType: "JSON",
      success: function (resdata) {
        updateCart();
      },
    });
  }
  function addToCart(d, redirect = true) {
    $.ajax({
      url: "/cart/add.js",
      type: "POST",
      data: d,
      dataType: "JSON",
      success: function (resdata) {
        if(redirect){
          window.location.href= $(document).find('[data-product-atc-a-ball]').attr('data-redirect');
        }
       
      },
    });
  }


  $(document).on("click", ".add-without-helium", function () {
    var selector = $(this);
    $(this).addClass('processing');
    $(document).find('[data-product-atc]').trigger('click');
    setTimeout(function(){
       $(document).find('.clsoe-popup').trigger('click');
        $(selector).removeClass('processing')
    },500)
    
  });
    $(document).on("click", ".add-with-helium", function () {
    var selector = $(this);
    $(this).addClass('processing');
     var variant = $(this).attr('data-variant'),
         qty = $(this).attr('data-quantity');
     $.ajax({
      url: "/cart/add.js",
      type: "POST",
      data: {id:variant,quantity:qty},
      dataType: "JSON",
      success: function (resdata) {
        $(document).find('[data-product-atc]').trigger('click');
        $(selector).removeClass('processing');
      },
    });
   
    
  });

  
  $(document).on("click", ".flat-popup-open", function () {
    $(document).find('.popup-flat-m').addClass('open');
  });
  $(document).on("click", ".clsoe-popup", function () {
    $(document).find('.popup-flat-m').removeClass('open');
  });

 
  
  $(document).on("click", "[data-product-atc-a-ball]", function () {
    var form = $(this).closest("form"),
      formdata = $(form).serialize();
    $(this).addClass('processing')
    addToCart(formdata);
  });
  $(document).on("click", ".removeItem", function () {
    var parent = $(this).closest(".cart-items-inner"),
      varaintId = $(parent).attr("data-var_id");
    changeCart(varaintId, 0);
  });
  $(document).on("click", ".mobile-only.cross-button", function () {
    var parent = $(this).closest(".location-app-code");
    
    $(parent).find('.first-app-dra').hide();
  });
  $(document).on("click", "#locations-app-1-2", function () {
    var parent = $(this).closest(".location-app-code");
    
    $(parent).find('.first-app-dra').show();
  });

  
  
  $(document).on("change", '[name="quantity"]', function () {
    var parent = $(this).closest(".cart-items-inner"),
      varaintId = $(parent).attr("data-var_id");
    changeCart(varaintId, $(this).val());
  });
  
});

